import VueCookies from 'vue-cookies';

export const UrlModule = {
	namespaced: true,
	state: {
		previous: '/'
	},

	actions: {
		setPrevious({commit}, url) {
			commit('SET_PREVIOUS', url);
		}
	},

	mutations: {
		SET_PREVIOUS(state, previousUrl) {
			state.previous = previousUrl;
			VueCookies.set('SET_PREVIOUS', decodeURI(previousUrl));
		}
	}
}
